import { useMemo } from "react";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  field: number;
  fieldValue: string;
  tipo: number;
  status: number;
  onFieldChange: (v: number) => void;
  onFieldValueChange: (v: string) => void;
  onTipoChange: (v: number) => void;
  onStatusChange: (v: number) => void;
  onClearFilters: () => void;
};

export const Header = ({
  field,
  fieldValue,
  tipo,
  status,
  onFieldChange,
  onFieldValueChange,
  onTipoChange,
  onStatusChange,
  onClearFilters,
}: Props) => {
  const typeFieldOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Produto/Serviço',
      },
      {
        id: 2,
        label: 'Unidade',
      },
      {
        id: 3,
        label: 'Norma',
      },
      {
        id: 4,
        label: 'Código',
      }
    ];
  }, [
  ]);

  const typeOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Todos',
      },
      {
        id: 2,
        label: 'Produtos',
      },
      {
        id: 3,
        label: 'Serviços',
      }
    ];
  }, [
  ]);

  const statusOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Todos',
      },
      {
        id: 2,
        label: 'Ativos',
      },
      {
        id: 3,
        label: 'Inativos',
      }
    ];
  }, [
  ]);

  return (
    <CascateList title='Filtros' defaultOpen={true}>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-2">
          <div className="w-full col-span-1 md:col-span-2 grid grid-cols-3 gap-2">
            <DefaultSelectInput
              name='field'
              label=''
              showSelectionLabel={false}
              options={typeFieldOptions}
              value={field}
              onChangeValue={e => onFieldChange(Number(e))}
            />

            <div className="w-full col-span-2">
              <DefaultInput
                name="field_value"
                value={fieldValue}
                onChangeValue={e => onFieldValueChange(e)}
              />
            </div>
          </div>

          <DefaultSelectInput
            name='tipo'
            label='Tipo'
            showSelectionLabel={false}
            options={typeOptions}
            value={tipo}
            onChangeValue={e => onTipoChange(Number(e))}
          />

          <DefaultSelectInput
            name='status'
            label='Status'
            showSelectionLabel={false}
            options={statusOptions}
            value={status}
            onChangeValue={e => onStatusChange(Number(e))}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}